export default __webpack_public_path__ + "static/Group 20-e2ccd2b65565c25134d951b5bc13d358.jpg";